// @ts-nocheck
import { useEffect, useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/query-client";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import EditClaimModal from "@/components/claims/modals/edit-claim-modal";

/**
 * Standalone page rendered inside the edit-claim popup window.
 *
 * URL params: claim_id, session_key
 * sessionStorage[session_key]: { claim: <claim object> }
 *
 * On save, posts { type: "claim-saved", claimId } to opener then closes.
 */
function EditClaimPopupInner() {
  const params = new URLSearchParams(window.location.search);
  const claimId = params.get("claim_id") ?? "";
  const sessionKey = params.get("session_key") ?? "";

  const sessionRaw = sessionKey ? sessionStorage.getItem(sessionKey) : null;
  const session = sessionRaw ? JSON.parse(sessionRaw) : {};
  const claim = session.claim ?? {};

  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!open) {
      window.close();
    }
  }, [open]);

  function handleSaved() {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type: "claim-saved", claimId },
        window.location.origin
      );
    }
    window.close();
  }

  return (
    <EditClaimModal
      open={open}
      onOpenChange={(v) => {
        if (!v) setOpen(false);
      }}
      claimId={claimId}
      claim={claim}
      onSaved={handleSaved}
    />
  );
}

export function EditClaimPopupPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <EditClaimPopupInner />
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
